import { gql } from '@apollo/client';

const CLINIC_STUDIES_QUERY = gql`
  query clinicStudiesSearch($filter: ClinicStudyFilterInput, $limit: Int) {
    clinicStudies(filter: $filter, limit: $limit) {
      id
      facility {
        contact {
          country
        }
      }
      friendlyId
      externalSource {
        provider
        externalId
      }
      info {
        patient {
          firstName
          lastName
          dob
          gender
        }
        followOnStudy {
          studyType
        }
      }
      start
      stop
      studyType
      timezone
      clinicTicket {
        id
      }
    }
  }
`;

export default CLINIC_STUDIES_QUERY;
